import Decimal from 'decimal.js-light'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { imageUrls } from './assets'
import resourceLoader from './utils/resourceLoader'
import { ENV } from './constants'

import './index.scss'
import './theme.scss'

Decimal.set({ toExpPos: 999 })

if (ENV === 'DEV') {
  // document.body.setAttribute('data-debug', '1')
}

resourceLoader(
  imageUrls.map((imgUrl) => ({
    type: 'image',
    url: imgUrl,
  })),
  {
    progress: (current, total) => {
      console.log(`loading ${current}/${total}`)
    },
  }
)
  .then(() => {
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById('root')
    )
  })
  .catch(() => {})
